/**
 * Returns a new Promise witch resolves after a given number of milliseconds
 *
 * @param {Number} ms
 * @returns {Promise.<void>}
 */
function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export default wait;
